import { RightOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useCreateTransactionRuleContext } from './CreateTransactionRuleContext';
import { CreateTransactionRuleStep } from './types';

const stepToLabel = {
  [CreateTransactionRuleStep.SelectTransaction]: 'Choose request',
  [CreateTransactionRuleStep.CreateTransactionSelectors]: 'Edit the selectors',
  [CreateTransactionRuleStep.CreateTransactionModifiers]: 'Modify data',
  [CreateTransactionRuleStep.CreateResponseVisualization]:
    'Visual representation',
  [CreateTransactionRuleStep.GeneralSettings]: 'Add general settings',
};

export const CreateTransactionRuleStepsHeader = () => {
  const { stepIndex, steps } = useCreateTransactionRuleContext();

  return (
    <div className="flex gap-1.5  px-8 py-5">
      {steps.map((step, index) => {
        const isCurrentStep = index === stepIndex;
        const isLastStep = index === steps.length - 1;

        return (
          <div
            className="flex gap-1.5 items-center select-none"
            key={step}
          >
            <div
              className={classNames(
                'w-5 h-5 m-0.5  text-white text-sm rounded-full flex flex-col items-center justify-center font-normal',
                isCurrentStep ? 'bg-ds-primary-300' : 'bg-ds-natural-400'
              )}
            >
              {index + 1}
            </div>
            <TextBase
              label={stepToLabel[step]}
              color={
                isCurrentStep ? 'text-ds-primary-300' : 'text-ds-natural-600'
              }
            />
            {!isLastStep && (
              <RightOutlineIcon
                size={20}
                color={ColorHex.natural200}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
